export default __webpack_public_path__ + "static/media/solidworks-model.ea6fe705.png";